module.exports = __webpack_public_path__ + "img/icon-remove.f851abc9.svg";